import { Dialog } from '@components/dialog';
import { FormControlLabel } from '@components/formControlLabel';
import { RadioButton } from '@components/radioButton';
import { ToastType } from '@components/toast';
import { QuoteGetResponse } from '@lio/api-types';
import { Box } from '@mui/material';
import { useResetQuoteDefaults } from '@services/quotes/useResetQuoteDefaults';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

type ResetQuoteDefaultsDialogProps = {
  open: boolean;
  quote: QuoteGetResponse;
  handleCloseDialog: () => void;
};

export const ResetQuoteDefaultsDialog = ({ open, quote, handleCloseDialog }: ResetQuoteDefaultsDialogProps) => {
  const [resetUneditedFields, setResetUneditedFields] = useState(true);
  const resetQuoteDefaults = useResetQuoteDefaults();

  const handleChange = () => {
    setResetUneditedFields((state) => !state);
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = async () => {
    await resetQuoteDefaults.reset(
      { quoteId: quote.id, resetAllQuoteItemAttributesThatDefault: !resetUneditedFields },
      {
        onSuccess: () => {
          handleCloseDialog();
        },
        onError: () => {
          enqueueSnackbar(`Resetting defaults of quote #${quote?.policyNumber?.policyNumber} has failed.`, {
            preventDuplicate: true,
            variant: ToastType.Error,
          });
        },
      },
    );
  };

  return (
    <Dialog
      open={open}
      title={`Reset Defaults on Quote #${quote?.policyNumber?.policyNumber}`}
      showBorders={false}
      handleCloseDialog={handleCloseDialog}
      primaryBtnText='Reset Defaults'
      isPrimaryBtnLoading={resetQuoteDefaults.isPending}
      primaryBtnAction={handleSubmit}
      secondaryBtnText='Cancel'
      secondaryBtnAction={handleCloseDialog}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', margin: 'auto', padding: '20px' }}>
        <FormControlLabel
          key='default'
          checked={resetUneditedFields}
          control={<RadioButton value={resetUneditedFields} onChange={handleChange} />}
          label='Reset unedited field defaults'
        />
        <FormControlLabel
          key='custom'
          checked={!resetUneditedFields}
          control={<RadioButton value={!resetUneditedFields} onChange={handleChange} />}
          label='Reset all defaults'
        />
      </Box>
    </Dialog>
  );
};
